import React from 'react';
import { FaSpinner } from 'react-icons/fa';
import './Button.scss';

type ButtonProps = {
  isLoading: boolean;
  isSubmit?: boolean;
  className?: string;
  onClick?: (() => void) | (() => Promise<void>) | undefined;
  children: React.ReactNode;
  disabled?: boolean;
};

const Button: React.FC<ButtonProps> = ({
  isLoading,
  isSubmit,
  onClick,
  children,
  disabled,
  className
}) => {
  return (
    <button
      type={isSubmit ? 'submit' : 'button'}
      className={`custom-button ${className}`}
      onClick={
        onClick ??
        (() => {
          /* Do nothing */
        })
      }
      disabled={isLoading || disabled}
    >
      {isLoading ? <FaSpinner className="spinner" /> : children}
    </button>
  );
};

export default Button;
